import { render } from "./reportSaleCommission.vue?vue&type=template&id=2a7ae67d"
import script from "./reportSaleCommission.vue?vue&type=script&lang=js"
export * from "./reportSaleCommission.vue?vue&type=script&lang=js"

import "./reportSaleCommission.vue?vue&type=style&index=0&id=2a7ae67d&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__